// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  font-family: \"Product Sans\", sans-serif !important;\n  font-weight: 400;\n}", ""]);
// Exports
module.exports = exports;
